import { render, staticRenderFns } from "./subAddCommercialGrade.vue?vue&type=template&id=d5a9306e&scoped=true"
import script from "./subAddCommercialGrade.vue?vue&type=script&lang=js"
export * from "./subAddCommercialGrade.vue?vue&type=script&lang=js"
import style0 from "./subAddCommercialGrade.vue?vue&type=style&index=0&id=d5a9306e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a9306e",
  null
  
)

export default component.exports